import { statusFilters } from "components";
import { typedQueryClient, useTypedQuery } from "hooks";
import { AppointmentsQueryKeys } from "modules/Appointments/queryKeys";
import { APPOINTMENTS_STORAGE_KEYS } from "modules/Appointments/storageKeys";
import { getPreference, setPreference } from "utils/common";

import type { StatusFilter } from "components";

export const useSelectedIdentifiersToFilter = () =>
  useTypedQuery({
    queryKey: AppointmentsQueryKeys.selectedIdentifiersToFilter,
    initialData: getPreference(APPOINTMENTS_STORAGE_KEYS.StatusIdentifierPreference, [...statusFilters])
  }).data;

export const setSelectedIdentifiersToFilter = (selectedIdentifierFilters: StatusFilter[]) => {
  typedQueryClient.setQueryData(AppointmentsQueryKeys.selectedIdentifiersToFilter, [...selectedIdentifierFilters]);
  setPreference(APPOINTMENTS_STORAGE_KEYS.StatusIdentifierPreference, [...selectedIdentifierFilters]);
};
